import {
  Badge,
  Group,
  HoverCard,
  LoadingOverlay,
  NumberFormatter,
  Paper,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconArrowDown, IconArrowUp } from "@tabler/icons-react";
import React, { useMemo } from "react";

const PaidUsers = ({ stats, defaultStats, loading }) => {
  const result = useMemo(() => {
    const previous = stats.stats_previous_range?.paid_users;
    const actual = stats.stats_current_range?.paid_users;
    const newUsers = actual - previous;
    const rate = (newUsers / actual) * 100;

    return {
      newUsers,
      rate: rate ? rate.toFixed(1) : 0,
    };
  }, [stats]);

  return (
    <HoverCard position="right">
      <HoverCard.Target>
        <Paper
          component={Stack}
          gap={0}
          p={"lg"}
          px={"xl"}
          radius={"md"}
          bg={"#fff"}
          w={"100%"}
          pos={"relative"}
        >
          <LoadingOverlay visible={loading} />
          <Text size="xl">Total users payants</Text>

          <Group>
            <Text fz={30} fw={600}>
              <NumberFormatter
                value={defaultStats.stats_current_range.paid_users}
              />{" "}
              <Text
                span
                fz={24}
                fw={600}
                c={result.newUsers > 0 ? "green.8" : "red.6"}
              >
                ({result.newUsers > 0 ? "+" : ""}
                {result.newUsers})
              </Text>
            </Text>

            <Badge
              leftSection={
                result.rate < 0 ? (
                  <IconArrowDown size={16} />
                ) : (
                  <IconArrowUp size={16} />
                )
              }
              size="lg"
              variant="light"
              color={result.rate < 0 ? "red.6" : "green.8"}
              ml={"auto"}
            >
              {result.rate}%
            </Badge>
          </Group>
        </Paper>
      </HoverCard.Target>

      <HoverCard.Dropdown>
        <Stack>
          <Text size="lg">
            <b>{stats.stats_current_range?.paid_users}</b> comptes payants sur
            cette période
          </Text>
          <Text size="lg">
            <b>{stats.stats_previous_range?.paid_users}</b> comptes payants sur
            la période d'avant
          </Text>
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};

export default PaidUsers;
